'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SortableComposition = require('./SortableComposition');

Object.defineProperty(exports, 'sortable', {
  enumerable: true,
  get: function get() {
    return _SortableComposition.SortableComposition;
  }
});


//////////////////
// WEBPACK FOOTER
// C:/Work/repo/metabase/metabase_wh/node_modules/react-sortable/lib/index.js
// module id = 734
// module chunks = 7